/* view_more.icon.svg.js */

module.exports = {
    icon: `    
            <svg viewBox="0 0 16 16" preserveAspectRatio="none">
            <path class="foreground-gl" d="M4.9,0C2.3,0,0.1,2,0.1,3.3C0,4.6,2.3,6.7,4.9,6.7c2.7,0,4.8-2.3,4.8-3.3C9.7,2.4,7.6,0,4.9,0z M4.9,5.8
                c-1.4,0-2.5-1.1-2.5-2.4s1.1-2.4,2.5-2.4c1.4,0,2.5,1.1,2.5,2.4S6.3,5.8,4.9,5.8z"/>
            <path class="foreground-gl" d="M5.2,2.1C5,2.7,4.4,3.2,3.7,3.2c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.1c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3
                C6.2,2.7,5.8,2.2,5.2,2.1z"/>
            <path class="foreground-gl" d="M15.5,9.2h-15C0.2,9.2,0,8.9,0,8.7s0.2-0.5,0.5-0.5h15c0.3,0,0.5,0.2,0.5,0.5S15.8,9.2,15.5,9.2z"/>
            <path class="foreground-gl" d="M15.5,5.7H12c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h3.5C15.8,4.8,16,5,16,5.2S15.8,5.7,15.5,5.7z"/>
            <path class="foreground-gl" d="M15.5,2.3H12c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h3.5c0.3,0,0.5,0.2,0.5,0.5S15.8,2.3,15.5,2.3z"/>
            <path class="foreground-gl" d="M15.5,12.6h-15c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h15c0.3,0,0.5,0.2,0.5,0.5S15.8,12.6,15.5,12.6z"/>
            <path class="foreground-gl" d="M15.5,16h-15C0.2,16,0,15.8,0,15.5C0,15.2,0.2,15,0.5,15h15c0.3,0,0.5,0.2,0.5,0.5C16,15.8,15.8,16,15.5,16z"/>
            </svg>
         `
};
